<template>
  <div class="flex items-center justify-center w-full my-12">
    <div class="w-full max-w-[1200px] lg:px-0 px-4">
      
      <!-- ENCABEZADO CENTRADO -->
      <div class="text-center mb-8">
        <h2 class="lg:text-[32px] md:text-[28px] text-[24px] text-hgold font-serif font-normal">
          {{ titulo }}
        </h2>
        <p class="text-gray-500 text-sm mt-1">
          {{ subtitulo }}
        </p>
      </div>

      <!-- LEYENDA (Alineada a la derecha al quitar los filtros) -->
      <div class="flex justify-end items-center mb-8">
        <div class="flex items-center gap-5 text-sm text-gray-600">
          <div class="flex items-center gap-2">
            <span class="w-3.5 h-3.5 rounded-full bg-hwine inline-block"></span>
            <span>Disponible</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-4 h-[2px] bg-gray-300 inline-block"></span>
            <span>No disponible</span>
          </div>
        </div>
      </div>
      
      <!-- TABLA DE INICIOS -->
      <div class="w-full overflow-x-auto">
        <table class="w-full min-w-[520px] text-left border-collapse">
          <thead>
            <tr class="border-b border-gray-200">
              <th class="sticky left-0 z-20 bg-white w-1/2 sm:w-2/5 py-3 pr-3 text-gray-700 font-serif font-semibold text-sm sm:text-base align-bottom max-w-[180px] sm:max-w-none whitespace-normal break-words border-r border-gray-100">
                Oferta Académica
              </th>
              <th
                v-for="per in periodos"
                :key="per.id"
                class="text-center py-2 px-2 font-serif text-sm font-normal text-gray-700 leading-tight min-w-[70px]"
              >
                <div class="font-semibold">{{ per.mes }}</div>
                <div class="text-gray-500 text-xs">{{ per.periodo }}</div>
              </th>
            </tr>
          </thead>
          
          <tbody>
            <tr class="group border-b border-gray-100 hover:bg-gray-50/50 transition-colors">
              <td class="sticky left-0 z-10 bg-white group-hover:bg-gray-50 transition-colors py-3 pr-3 text-xs sm:text-sm text-hgray max-w-[180px] sm:max-w-none whitespace-normal break-words border-r border-gray-100">
                <span class="font-medium text-hgold">{{ nombre }}</span>
              </td>

              <!-- Renderizado desde las props -->
              <td
                v-for="(activo, pIndex) in inicios"
                :key="pIndex"
                class="text-center py-3 px-2 align-middle"
              >
                <span
                  v-if="activo"
                  class="inline-block w-3.5 h-3.5 rounded-full bg-hwine align-middle"
                  title="Disponible"
                ></span>
                <span
                  v-else
                  class="inline-block w-4 h-[2px] bg-gray-300 align-middle"
                  title="No disponible"
                ></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

// Definición de la interfaz para las Props
interface Props {
  nombre: string;
  inicios: boolean[];
  titulo?: string;
  subtitulo?: string;
}

// Asignación de valores por defecto mediante withDefaults
withDefaults(defineProps<Props>(), {
  titulo: 'Calendario',
  subtitulo: 'Consulta la disponibilidad de inicios de cada programa y modalidad.'
})

interface Periodo {
  id: string;
  mes: string;
  periodo: string;
}

// 8 periodos fijos
const periodos = ref<Periodo[]>([
  { id: '1', mes: 'Sept.', periodo: '2026' }, //[cite: 1]
  { id: '2', mes: 'Ene.', periodo: '2027' },  //[cite: 1]
  { id: '3', mes: 'Abr.', periodo: '2027' },  //[cite: 1]
  { id: '4', mes: 'Jul.', periodo: '2027' },  //[cite: 1]
  { id: '5', mes: 'Sept.', periodo: '2027' }, //[cite: 1]
  { id: '6', mes: 'Ene.', periodo: '2028' },  //[cite: 1]
  { id: '7', mes: 'Abr.', periodo: '2028' },
  { id: '8', mes: 'Jul.', periodo: '2028' }
])
</script>